<template>
    <div>
        <el-row>
            <el-col :span="3" v-if="hiddenImg!=true">
                <img src="../../../../../assets//img/product/item-icon.png"></img>
            </el-col>
            <el-col :span="21">
                {{ content }}
            </el-col>
        </el-row>
    </div>
</template>
<script>
export default {
    props: ['content','hiddenImg']
}
</script>
<style lang="less" scoped>
img {
    display: inline-block;
    width: 2em;
    margin-top: 0;
}
</style>